import React, { Component } from 'react'
import { connect } from 'react-redux'
import { nest, compose, withState, withHandlers } from 'recompose'
import CSSModules from 'helpers/CSSModulesUtil'

import progressBarHoc from 'containers/Async/AsyncProgressBar'
import Specifications from 'containers/Project/Specifications/index'
import Section from 'components/custom/Section/Section'
import CardHeader from 'components/custom/Card/CardHeader'
import Collapse from 'components/fulcrum/collapse/Collapse'
import LastUpdated from 'components/display/LastUpdated'
import Card from './Card'
import Actions from './Actions'
import Divider from 'components/fulcrum/divider/Divider'

import styles from './styles.scss'

import {
  FETCH_PROJECT_REVISIONS,
  FETCH_REVISION_DATA,
} from 'containers/Project/Revision/constants'

import {
  FETCH_FORM_ELEMENTS,
  FETCH_ELEMENT_REFERENCES,
} from 'containers/Project/constants'
import { latestRevisionCreatedBy, latestRevisionCreatedAt } from 'containers/Project/Revision/selectors'

const ProgressBar = progressBarHoc(
  [
    FETCH_FORM_ELEMENTS,
    FETCH_ELEMENT_REFERENCES,
    FETCH_PROJECT_REVISIONS,
    FETCH_PROJECT_REVISIONS,
    FETCH_REVISION_DATA,
  ]
)

const mapStateToProps = (state) => {
  return {
    latestRevisionsCreatedBy: latestRevisionCreatedBy(state),
    latestRevisionsCreatedAt: latestRevisionCreatedAt(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

class ProjectSpecifications extends Component {
  render() {
    const {
      collapse,
      id,
      toggleCollapse,
      cloneProject,
      latestRevisionsCreatedBy,
      latestRevisionsCreatedAt
    } = this.props

    return (
      <Section>
        <Card>
          <CardHeader title='Specifications'>
            <Actions
              collapse={collapse}
              id={id}
              toggleCollapse={toggleCollapse}
              cloneProject={cloneProject}
            />
          </CardHeader>
          <LastUpdated name={latestRevisionsCreatedBy} date={latestRevisionsCreatedAt} />
          <Divider className={styles.divider}/>
          <Collapse collapse={collapse}>
            <Specifications />
            <ProgressBar/>
          </Collapse>
        </Card>
      </Section>
    )
  }
}

const withCollapse = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('collapse', 'toggleCollapse', false),
  withHandlers({
    toggleCollapse: ({ toggleCollapse }) => () => toggleCollapse(t => !t)
  }),
  CSSModules(styles)
)

export default compose(
  withCollapse,
)(ProjectSpecifications)
